import { AppPageHeader } from '@/components/_common';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { ListEmployeesQuery } from '@/core/domain/enterprise/Employees/Employees.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Col, Form, Input, Row } from 'antd';
import { useIntl } from 'react-intl';

function EmployeeFiltersTable({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListEmployeesQuery>) {
  const intl = useIntl().formatMessage;

  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      searchValue={queryParams?.search}
      extraFilters={
        <Form>
          <Row gutter={[16, 16]}>
            <Col span={24} md={6}>
              <Input
                name="registry"
                value={queryParams?.registry}
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, registry: value }))
                }
                placeholder={intl({
                  id: 'employee.filter.registry',
                })}
              />
            </Col>

            <Col span={24} md={6}>
              <Input
                name="function"
                value={queryParams?.function}
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, function: value }))
                }
                placeholder={intl({
                  id: 'employee.filter.function',
                })}
              />
            </Col>

            <Col span={24} md={6}>
              <OrderExtraFilter
                value={queryParams?.order}
                onChange={(value) =>
                  setQueryParams((prev) => ({
                    ...prev,
                    order: value,
                  }))
                }
              />
            </Col>

            <Col span={24} md={6}>
              <ActiveExtraFilter
                value={queryParams?.isActive}
                onChange={(value) =>
                  setQueryParams((prev) => ({
                    ...prev,
                    isActive: value as unknown as boolean,
                  }))
                }
              />
            </Col>
          </Row>
        </Form>
      }
    />
  );
}

export default EmployeeFiltersTable;
